import React from "react";

const EarningStats = ({ stats }) => {

    const cards = [

        {
            title: "Total Revenue",
            value: `₹${stats.totalRevenue || 0}`,
        },

        {
            title: "Platform Commission",
            value: `₹${stats.platformCommission || 0}`,
        },

        {
            title: "Provider Earnings",
            value: `₹${stats.providerEarnings || 0}`,
        },

        {
            title: "Delivery Earnings",
            value: `₹${stats.deliveryEarnings || 0}`,
        },

        {
            title: "Total Orders",
            value: stats.totalOrders || 0,
        },

    ];

    return (

        <div className="earning-stats">

            {cards.map((card) => (

                <div
                    key={card.title}
                    className="earning-card"
                >

                    <h4>{card.title}</h4>

                    <h2>{card.value}</h2>

                </div>

            ))}

        </div>

    );

};

export default EarningStats;